// extracted by mini-css-extract-plugin
module.exports = {"editSysTimeBox":"editSysTimeBox--YmyiU","addStar":"addStar--Guumm","tip":"tip--pAvT3"};